'use strict';

function _CreditScoreController() {
  this.id = null;
  this.node = null;
  this.extends = [];
  this.declaredClass = null;

  this._creditRating = null;
  this._creditScoreCreatedAtDate = null;

  this.init = function () {
    this._productSettings = new ProductSettings(this.presenter);
  };

  this.initAllReady = function () {};

  this._loadCreditScoreModel = function () {
    if (!this.presenter.models.creditScore) {
      this._creditScoreModelCallbackId = this.presenter.addCallbackToAction('account.get_credit_score', this.onCreditScoreModelReady.bind(this));
      this.presenter.createModel('creditScore', { action: 'account.get_credit_score' });
    } else {
      this.onCreditScoreModelReady();
    }
  };

  this._abortLoadCreditScoreModel = function () {
    if (this._creditScoreModelCallbackId) {
      this.presenter.removeCallbackFromAction('account.get_credit_score', this._creditScoreModelCallbackId);
    }
  };

  this.onCreditScoreModelReady = function () {
    var indexOfLatestCS = 0;
    var indexOfPreviousValidCS = 1;
    this._creditScore = this.presenter.models.creditScore.credit_scores[indexOfLatestCS].score;
    this._creditScoreCreatedAtDate = this.presenter.models.creditScore.credit_scores[indexOfLatestCS].created_at;
    if (this._creditScore) {
      this._creditRating = this.presenter.models.creditScore.credit_scores[indexOfLatestCS].rating;
    } else {
      this._creditRating = 'no';
    }
  };

  // Used for previous score date display
  this._getCreditScoreCreatedAtDateMonthAndYear = function (previousDate, currentDate) {
    var _createdAtPreviousDate = new Date(previousDate);
    var _createdAtCurrentDate = new Date(currentDate);
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var month = months[_createdAtPreviousDate.getMonth()];
    var previousScoreYear = _createdAtPreviousDate.getFullYear(); // to display if not the same year
    var currentScoreYear = _createdAtCurrentDate.getFullYear(); // to check against
    if (previousScoreYear !== currentScoreYear) {
      return month + ' ' + previousScoreYear;
    }
    return month;
  };
}